import React from 'react'

import KinerjaKonfirmasiUnorApp from 'app/KinerjaPage/pages/KonfirmasiUnor'
import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    if (
      !toggle?.['kinerja-enabled'] ||
      !toggle?.['kinerja-konfirmasi-unor-enabled']
    ) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }

    return {
      props: {},
    }
  },
})

const KinerjaKonfirmasiUnor = () => {
  return <KinerjaKonfirmasiUnorApp />
}

KinerjaKonfirmasiUnor.Layout = KinerjaLayout

export default KinerjaKonfirmasiUnor
